import { createFileRoute } from '@tanstack/react-router';

import { VirtualOfficesSucursalesPage } from '@/features/virtual-offices/components/sucursales-page';

export const Route = createFileRoute('/_app/virtual-offices/sucursales')({
  component: VirtualOfficesSucursalesPage,
});
